import PaymentError from './PaymentError.js'

export default class InvalidPriceError extends PaymentError {}
